// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React from 'react';
import {img_url} from '../img_url';
import {use_article_links} from './use_article_links';
import styles from './share.module.less';
import cn from 'classnames';

interface i_share_props {
    article_id: string;
    article_title: string;
}
export const Share = (props:i_share_props)=>{
    const {facebook_link, twitter_link, copy} = use_article_links(props);
    return <div className={styles.root}>
      <a href={facebook_link}><img className={cn(styles.img, 'lazyload')}
        alt="facebook" src={img_url('social/facebook.svg')}/></a>
      <a href={twitter_link}><img className={cn(styles.img, 'lazyload')}
        alt="twitter" src={img_url('social/twitter.svg')}/></a>
      <div onClick={copy} className={styles.copy_link}>
        <img src={img_url('social/copy_link.svg')} alt="copy"
          className="lazyload"/>
      </div>
    </div>;
};
